import InstallationInfoPage from './InstallationInfoPage';

export default InstallationInfoPage;
